// The cell fieldId will have the form: gridId_attId_index
// The key to access to the field props will have the form: rowIndex_columnIndex
import { arrayOrArray } from '../../utils/util';
import {
  TApiaDataGridField,
  TApiaDataGridFieldRow,
  TApiaDataGridFieldValue,
} from './types';

export function makeCellAccessKey(
  fieldId: string,
  rowIndex: number,
  columnIndex: number,
) {
  return `${fieldId}_${rowIndex}_${columnIndex}`;
}

export function getFieldValue(field: TApiaDataGridField, rowIndex: number) {
  if (field.fieldValue) return arrayOrArray(field.fieldValue)[rowIndex];
  if (field.row) return arrayOrArray(field.row)[rowIndex];
  return { value: '' };
}

export function makeCellFieldId(
  gridId: string,
  columnIndex: number,
  rowIndex: number,
) {
  return `${gridId}_${columnIndex}_${rowIndex}`;
}

/**
 * This method provides a simple way to know if the value of a field coming from
 * Apia is a multiple one or not (eg: select vs input)
 */
export function isMultipleValue(
  value: TApiaDataGridFieldRow | TApiaDataGridFieldValue,
): value is TApiaDataGridFieldRow {
  return 'possibleValue' in value;
}
